import { render, staticRenderFns } from "./NetPremiumProperty.vue?vue&type=template&id=3cd4f6c0&scoped=true&"
import script from "./NetPremiumProperty.vue?vue&type=script&lang=js&"
export * from "./NetPremiumProperty.vue?vue&type=script&lang=js&"
import style0 from "./NetPremiumProperty.vue?vue&type=style&index=0&id=3cd4f6c0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd4f6c0",
  null
  
)

export default component.exports